module.exports = function() {
    var touchDevice = !!(("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch || navigator.msMaxTouchPoints);

    this.isTouch = function() {
        return touchDevice;
    };

    return $.Deferred().resolve().promise();
};
